export default "__VITE_ASSET__65edf703__"